import { t } from 'i18next';

export const chartConfig = {
  forecastProposal: {
    label: t('Forecast proposal', { ns: 'forecast' }),
    theme: {
      light: 'var(--chart-forecast-proposal)',
      dark: 'var(--chart-forecast-proposal)',
    },
  },
  realSales: {
    label: t('Real sales', { ns: 'forecast' }),
    theme: {
      light: 'var(--chart-real-sales)',
      dark: 'var(--chart-real-sales)',
    },
  },
  realSalesAverage: {
    label: t('Real sales average', { ns: 'forecast' }),
    theme: {
      light: 'var(--chart-real-sales-average)',
      dark: 'var(--chart-real-sales-average)',
    },
  },
  modelProposal: {
    label: t('Model proposal', { ns: 'forecast' }),
    theme: {
      light: 'var(--chart-model-proposal)',
      dark: 'var(--chart-model-proposal)',
    },
  },
  modelProposal2: {
    label: t('Model proposal 2', { ns: 'forecast' }),
    theme: {
      light: 'var(--chart-model-proposal-2)',
      dark: 'var(--chart-model-proposal-2)',
    },
  },
  validatedForecast: {
    label: t('Validated forecast', { ns: 'forecast' }),
    theme: {
      light: 'var(--chart-validated-forecast)',
      dark: 'var(--chart-validated-forecast)',
    },
  },
  b2bSales: {
    label: t('B2B sales', { ns: 'forecast' }),
    theme: {
      light: 'var(--chart-b2b-sales)',
      dark: 'var(--chart-b2b-sales)',
    },
  },
  productPriceIndex: {
    label: t('Price index', { ns: 'forecast' }),
    theme: {
      light: 'var(--chart-product-price)',
      dark: 'var(--chart-product-price)',
    },
  },
  stock: {
    label: t('Stock disponibility', { ns: 'forecast' }),
    theme: {
      light: 'var(--chart-stock)',
      dark: 'var(--chart-stock)',
    },
  },
};
